import { render, staticRenderFns } from "./GuppyChatPostList.vue?vue&type=template&id=5c4fb70d&"
import script from "./GuppyChatPostList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports